const intlText = (props, key) => props.intl.formatMessage({ id: key });

export { intlText };
